// extracted by mini-css-extract-plugin
export default {"invoiceTable":"invoice-view_invoiceTable__dU9cx","headerRow":"invoice-view_headerRow__GGNN8","invoiceDetailsSection":"invoice-view_invoiceDetailsSection__8Ln00"};